<template>
  <Modal :hideExit="false" breakLine @cancel="closeModal" classs="report-modal" mClass="p-4 pt-1">
    <template #header>
      <p class="typo-title1">{{ $t("analytic.ab.campReport") }}</p>
    </template>
    <template #default>
      <div class="row mb-2" v-if="details">
        <div class="col-7 mr-auto">
          <h2 class="typo-heading16 typo-medium text-light-high ellipsis">{{ details.name }}</h2>
        </div>
        <div class="col-2"></div>
        <div class="col-2 d-flex align-items-center justify-content-end">
          <span class="typo-paragraph14 text-light-high mr-1">{{ $t("generals.time") }}:</span>
          <DatePicker v-model="date" type="date" :disabled-date="outRangeDate" :placeholder="$t('datetime.whole', {type: $tc('lowerCase.campaign', 1)})" @change="loadData" format="DD-MM-YYYY" value-type="format">
            <template v-slot:header="{ emit }">
              <button class="mx-btn mx-btn-text" @click="emit(new Date())">{{ $t("datetime.today") }}</button>
              <button class="mx-btn mx-btn-text" @click="emit('')">{{ $t("datetime.whole", {type: $tc("lowerCase.campaign", 1)}) }}</button>
            </template>
          </DatePicker>
        </div>
      </div>
      <div class="row" v-if="details">
        <div class="col-12">
          <table class="statistic row mx-0">
            <thead class="col-12">
              <tr class="row typo-medium">
                <th class="typo-regular text-light-low col-2 col-mlg-3 text-left">{{ $t("analytic.ab.pageName") }}</th>
                <th class="typo-regular text-light-low col">
                  {{ $t("analytic.ab.trafficWeight") }}
                  <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.traffic')" iClass="ml-half" />
                </th>
                <th class="typo-regular text-light-low col">
                  {{ $t("analytic.ab.uniqPageviews") }}
                  <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.visitor')" iClass="ml-half" />
                </th>
                <th class="typo-regular text-light-low col">
                  {{ $t("analytic.ab.sessions") }}
                  <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.session')" iClass="ml-half" />
                </th>
                <th class="typo-regular text-light-low col">
                  {{ $tc("analytic.ab.pageviews") }}
                  <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.view')" iClass="ml-half" />
                </th>
                <th class="typo-regular text-light-low col">
                  {{ $t("analytic.ab.addToCart") }}
                  <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.addToCart')" iClass="ml-half" />
                </th>
                <th class="typo-regular text-light-low col">
                  {{ $t("analytic.ab.addToCartRate") }}
                  <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.addToCartRate')" iClass="ml-half" />
                </th>
                <!-- <th class="typo-regular text-light-low col">
                  {{ $tc("analytic.ab.conversion", 2) }}
                  <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.conversion')" iClass="ml-half" />
                </th>
                <th class="typo-regular text-light-low col">
                  {{ $t("analytic.ab.conversionRate") }}
                  <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.conversionRate')" iClass="ml-half" />
                </th> -->
              </tr>
            </thead>
            <tbody class="col-12">
              <template v-if="loading">
                <PageReportItem v-for="idx in 2" :key="'skeleton-row_' + idx" />
              </template>
              <template v-else>
                <PageReportItem v-for="(item, idx) in pages" :key="'page-row_' + idx" :item="item" />
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <template #footer> </template>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";
import { actions } from "@/store/analytic/types.js";
import PageReportItem from "./PageReportItem";
// import googleLogin from "@/mixins/googleLogin.js";
import errorHandle from "@/mixins/errorHandle.js";
import Icon from "@/core/shared/Icon.vue"
import DatePicker from "vue2-datepicker";
import { convertTZ } from '@/plugins/timemaker';

export default {
  name: "ReportModal",
  components: {
    PageReportItem,
    DatePicker,
    Icon
  },
  mixins: [/*googleLogin({ loading: false }), */ errorHandle()],
  props: {
    campaign: {
      type: Object,
      default: () => null
    },
    detailed: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    fetched: null,
    date: ""
  }),
  computed: {
    details() {
      let output = {};
      if (this.campaign) {
        for (const key in this.campaign) {
          if (key == "pages") {
            continue;
          }
          output[key] = JSON.parse(JSON.stringify(this.campaign[key]));
        }
      }
      if (this.fetched) {
        for (const key in this.fetched) {
          output[key] = this.fetched[key];
        }
      }
      return output;
    },
    isGA3() {
      if (this.campaign) {
        return (this.campaign.ga_tracking_id || "").toUpperCase().startsWith("UA-") || (this.campaign.ga_property_id || "").toUpperCase().startsWith("UA-");
      }
      return false;
    },
    pages() {
      return this.details.pages || [];
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions("analytic", {
      fetchReport: actions.GET_REPORT_ANALYTIC
    }),
    closeModal() {
      this.$emit("close");
    },
    async loadData() {
      if (!this.detailed && this.campaign) {
        this.loading = true;

        try {
          const pages = await this.fetchReport({
            id: this.campaign.id,
            date: this.date,
          });
          if (pages) {
            this.fetched = { pages };
          }
          this.loading = false;
        } catch (err) {
          let url = err.url;
          if (err.response && err.response.data) {
            url = err?.response?.data?.data?.url;
          }
          if (typeof url == "string") {
            // this.toggleLoading(true);
            // this.openGoogleLoginPopup(url);
            // window.addEventListener("message", this.listening, false);
            this.closeModal();
            this.$router.push({ name: "AccountSettings", query: { highlightGA: 1 } });
          } else {
            this.loading = false;
            this.closeModal();
          }
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        }
      }
    },
    outRangeDate(date) {
      date = convertTZ(date, tz);
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (this?.details?.ga_timezone) {
        tz = this.details.ga_timezone;
      }
      // convertTZ
      const startDate = convertTZ(new Date(this.details.started_at), tz);
      startDate.setHours(0, 0, 0, 0);
      const duration = this.details.duration;
      const endDate = convertTZ(new Date(startDate.getTime() + duration * 24 * 3600 * 1000), tz);
      return date < startDate || date > endDate;
    },
  }
};
</script>

<style lang="scss" scoped>
.report-modal::v-deep {
  .gp_modal-container {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
table.statistic {
  thead {
    th {
      border: 1px solid $light3;
      background: $light1;
      padding: 8px;
      border-collapse: collapse;

      &:not(.text-left) {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>0

<style lang="scss">
$popup-z-index: $popupOnModalIndex;
@import '~vue2-datepicker/scss/index.scss';
</style>
